import { TreeData } from '@atlaskit/tree'

import { transformExpandedTreeData } from '@helpers'

export const transformExpandedTrees = (trees: TreeData[]) => trees.map(transformExpandedTreeData)
